module.exports = __webpack_public_path__ + "static/img/s144.136f3531.png";